import Blog2GridContainer from "../../../../components/pages/blog/blogPage/Blog2Grid";

const Blog2Grid = () => {
  return <Blog2GridContainer />;
};

export default Blog2Grid;
